module.exports = __webpack_public_path__ + "static/img/bg-en.8f4b6c47.webp";